// @flow
import { connect } from 'react-redux';

import AlbumGallery from 'components/fragments/AlbumGallery';

import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/fragments/AlbumGallery';
import { displayModal } from 'actions/modalActions';

const mapStateToProps = (state: StateType): StateProps => ({
  album: state.albumState.album,
  status: state.albumState.albumStatus
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchProps => ({
  displayModal: (modalObject: string, content: any, force?: boolean) =>
    dispatch(displayModal(modalObject, content, force))
});

export default connect(mapStateToProps, mapDispatchToProps)(AlbumGallery);
